

// Generic Model Reducers
import { DefaultModelReducers } from '../../../redux/DefaultModelReducers';

// Generic Model Reducers
const defaults = DefaultModelReducers('MediaTag');
export default defaults;